export const formatTimeToClock = (millis) => {
  if (millis < 0) {
    millis = 0; // Default negative values to 0
  }

  const totalSeconds = Math.floor(millis / 1000);

  const hours = (Math.floor(totalSeconds / 3600) % 24)
    .toString()
    .padStart(2, "0");

  const minutes = Math.floor((totalSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");

  const seconds = (totalSeconds % 60).toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};
